import * as React from 'react';
import { Draggable } from 'react-beautiful-dnd';
import { makeStyles } from '@mui/styles';
import { ListItem } from '@mui/material';

import DataCard from './dataCard';
import { createTheme } from '@mui/material/styles';
const theme = createTheme();

const useStyles = makeStyles(() => ({
    draggingListItem: {
        // padding: theme.spacing(1, 0),
        // background: 'rgb(235,235,235)'
    },
    cardContent: {
        padding: 0,
        '&:last-child': {
            paddingBottom: 0,
        },
    },
    rowContent: {
        flex: 1,
        display: 'flex',
        flexDirection: 'row',
        flexFlow: 'row wrap',
        justifyContent: 'flex-start',
        // [theme.breakpoints.only('xs')]: {
        //     flexFlow: 'column wrap',
        //     flexDirection: 'column',
        // },
    },
    listItemContent: {
        padding: theme.spacing(1, 0),
    },
    paperContent: {
        boxShadow:
            'rgb(145 158 171 / 24%) 0px 0px 2px 0px, rgb(145 158 171 / 24%) 0px 16px 32px -4px',
        borderRadius: theme.spacing(1),
        padding: theme.spacing(1),
        backgroundColor: '#fff',
    },
}));

const DraggableListItem = (props) =>
{
    const classes = useStyles();
    const { item, index } = props;
    return (
        <Draggable draggableId={`draggable_${index}`} index={index}>
            {(provided, snapshot) => (

                <ListItem
                    ref={provided.innerRef}
                    {...provided.draggableProps}
                    {...provided.dragHandleProps}
                    className={snapshot.isDragging ? classes.draggingListItem : classes.listItemContent}>
                    <DataCard
                        classes={classes}
                        item={item}
                        index={index}
                        {...props}
                    />
                </ListItem>
            )}
        </Draggable>
    );
};

export default DraggableListItem;
